import type {
  CLSAttribution,
  FCPAttribution,
  INPAttribution,
  LCPAttribution,
  TTFBAttribution,
} from 'web-vitals/attribution';

/** `sessionStorage` key holding the `WebVitalsSession`. */
export const SESSION_KEY = 'web-vitals-session';

/**
 * Scalars only, and a cross-repo contract — changing a name here splits the
 * shared index silently. `satisfies` checks them against the library's types.
 * See docs/TELEMETRY.md.
 */
export const ATTRIBUTION_FIELDS = {
  LCP: [
    'target',
    'url',
    'timeToFirstByte',
    'resourceLoadDelay',
    'resourceLoadDuration',
    'elementRenderDelay',
  ] satisfies readonly (keyof LCPAttribution)[],
  INP: [
    'interactionTarget',
    'interactionType',
    'interactionTime',
    'inputDelay',
    'processingDuration',
    'presentationDelay',
    'loadState',
    'totalScriptDuration',
    'totalStyleAndLayoutDuration',
  ] satisfies readonly (keyof INPAttribution)[],
  CLS: [
    'largestShiftTarget',
    'largestShiftValue',
    'largestShiftTime',
    'loadState',
  ] satisfies readonly (keyof CLSAttribution)[],
  FCP: [
    'timeToFirstByte',
    'firstByteToFCP',
    'loadState',
  ] satisfies readonly (keyof FCPAttribution)[],
  TTFB: [
    'waitingDuration',
    'cacheDuration',
    'dnsDuration',
    'connectionDuration',
    'requestDuration',
  ] satisfies readonly (keyof TTFBAttribution)[],
} as const;
